import { makeStyles } from 'tss-react/mui';
import { themeProps } from './theme';
import { reportColors } from '../Widgets/Report/constants';

const useStyles = makeStyles()((theme) => ({
  compareReport: {
    background: theme.palette.primary.main,
    height: '100%',
    width: '100%',
    overflow: 'auto',
    '@media print': {
      '& *': {
        color: `${themeProps.colors.black} !important`,
      },

      '& h1,& h2, & a': {
        color: `${themeProps.colors.cobalt} !important`,
      },

      '& span': {
        color: `${themeProps.colors.white} !important`,
      },

      '& td, & th, & li': {
        '-webkit-print-color-adjust': 'exact',
        'print-color-adjust': 'exact',
      },
    },
  },
  main: {
    width: '80vw',
    margin: '0 auto',
    maxWidth: '800px',
    padding: '50px 0 2rem 0',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      margin: '0',
      padding: '70px 1rem 2rem 1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '50px',
    },
    '& aside': {
      fontSize: themeProps.textSize.h6,
    },
    '@media print': {
      width: '100% !important',
      padding: '0 !important',
      background: `${themeProps.colors.white} !important`,
    },
  },

  reportContainer: {
    '@media print': {
      width: '210mm',
    },
  },

  reportTitle: {
    marginTop: '30px',
    '@media print': {
      marginTop: '0 !important',
    },
  },
  header: {
    background: theme.palette.primary.dark,
    flex: '0 0 auto',
  },
  headerButton: {
    color: theme.palette.text.primary,
    marginLeft: '0.5rem',
    transition: 'all 0.3s',
    '&:hover': {
      background: theme.palette.text.primary,
      color: theme.palette.primary.main,
    },
    'headerButton > &': {
      borderBottom: '2px solid #fff',
    },
  },
  summaryTable: {
    width: '100%',
    '& td': {
      padding: '0.25rem 0.5rem',
    },
  },
  summaryTableBandCell: {
    minWidth: '10ch',
    textAlign: 'center',
    fontWeight: 'bold',
    color: themeProps.colors.white,

    '@media print': { color: `${themeProps.colors.white} !important` },
  },

  reportLogo: {
    display: 'none',
    '@media print': {
      display: 'block',
    },
  },

  page: {
    padding: '0 50px !important',
    pageBreakAfter: 'always',
  },
  textField: {
    width: '100%',
    paddingTop: '20px',
  },
  formContainer: {
    marginTop: '30px',
    justifyContent: 'center',
  },
  bubbleTextArea: {
    position: 'absolute',
    background: '#ccf0ec00',
    border: 'none',
    color: themeProps.colors.grey,
    fontSize: '10px',
    lineHeight: 1.5,
    top: '35px',
    left: '25px',
    height: '150px',
    width: '150px',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    whiteSpace: 'pre-wrap !important' as any,
    wordBreak: 'break-word', // Ensure long words break
    overflow: 'hidden !important', // Hide overflow, as html2canvas doesn't render scroll
    resize: 'none', // Prevent manual resizing if it were a textarea
  },
  reportContent: {
    padding: 0,
    color: themeProps.colors.grey,
    textAlign: 'left',
    margin: 'auto',
    width: '60%',
    background: '#fff',

    '& h3': {
      color: reportColors.blue,
      marginTop: '2rem',
      textAlign: 'center',
      fontWeight: themeProps.fontWeight.bold,
    },
    '& h4': {
      color: reportColors.blue,
      marginTop: '10px',
      fontWeight: themeProps.fontWeight.bold,
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      '& h4': {
        textAlign: 'center',
      },
    },
    '@media print': {
      overflow: 'hidden',
      width: '210mm',
    },
  },
  reportHeader: {
    display: 'none',
    justifyContent: 'space-between',
    height: '80px',
    width: '210mm',
    backgroundColor: '#cdf1ec',
    '-moz-print-color-adjust': 'exact',
    'print-color-adjust': 'exact',
    '@media print': {
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      '@supports (-moz-appearance: none)': {
        position: 'absolute',
        top: '0',
        left: '0',
      },
    },
  },

  startingPage: {
    padding: '0 50px',
    marginTop: '0 !important',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  headerText: {
    color: reportColors.lightGrey,
    // position: 'absolute',
    // top: '10px',
    // left: '10px',
    // textAlign: 'left',
  },
  reportFooter: {
    display: 'none',
    justifyContent: 'space-between',
    backgroundColor: '#cdf1ec',
    width: '210mm',
    height: '70px',
    '@media print': {
      display: 'flex',
      position: 'fixed',
      top: '280mm',
      left: 0,
    },
  },
  printBtn: {
    display: 'flex',
    justifyContent: 'end',
    '@media print': {
      display: 'none',
    },
  },
  pieLegendImg: {
    width: '25%',
    padding: '10px',
    [theme.breakpoints.down('lg')]: {
      width: '50%',
    },
  },
  portalLinkImg: {
    width: '25%',
    marginTop: '50px',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      marginTop: '10px',
    },
  },
}));

export default useStyles;
